import { QpDateService } from '@library/services/qp-date/qp-date.service';
import { SERVER_API_URL } from '@one/app/app.constants';
import { confirmFindingsSummaryReviewSuccess } from '@one/app/pages/isp/pages/inspection/pages/id/shared/services/store/isp-inspection-id-workflow-store.actions';
import { InspectionId } from '@one/app/pages/isp/shared/models/isp-inspection.models';
import { IFindingsSummaryReviewConfirmationDTO } from '@one/app/shared/models/workflow/workflow.models';
import { ActionsQueueService } from '@one/app/shared/services/actions-queue/actions-queue.service';
import { DatabaseService } from '@one/app/shared/services/database/database-inspection.service';
import { IStoreState } from '@one/app/store/store.models';
import { HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class FindingsSummaryReviewSyncService {
  private readonly _databaseService = inject(DatabaseService);
  private readonly _actionsQueueService = inject(ActionsQueueService);
  private readonly _store = inject(Store<IStoreState>);
  private readonly _qpDateService = inject(QpDateService);

  public async confirmLocally(inspectionId: InspectionId): Promise<void> {
    await this._databaseService.saveInspectionFindingsSummaryReview(inspectionId, { isConfirmed: true });
    this._store.dispatch(confirmFindingsSummaryReviewSuccess());
  }

  public async scheduleConfirmSync(inspectionId: InspectionId): Promise<void> {
    const url = `${SERVER_API_URL}api/inspections/${inspectionId}/findings-summary-review`;
    const body: IFindingsSummaryReviewConfirmationDTO = {
      confirmationTime: this._qpDateService.getDate(),
      confirmationTimezone: this._qpDateService.getTimezone(),
    };
    const request = new HttpRequest<IFindingsSummaryReviewConfirmationDTO>('PUT', url, body);

    await this._actionsQueueService.addAction(request);
  }

  public async confirmAndSchedule(inspectionId: InspectionId): Promise<void> {
    await this.confirmLocally(inspectionId);
    await this.scheduleConfirmSync(inspectionId);
  }
}
